export * from './assessment/assessment.component';
export * from './holidays/holidays.component';
export * from './timetable/timetable.component';
export * from './year-calender/year-calender.component';
export * from './smsmarks/smsmarks.component';